<ng-container>
  @if (showBidListActionBar) {
    <div class="footer position-fixed w-100" aria-label="action-list">
      <ng-container class="action-list-wrapper">
        <p data-test-id="app-bidlist-action-bar-e-remove-vehicle-text" data-testid="bidlist-action-bar-remove-vehicle-text">
          {{bidListActionBarTranslations.bidListYouSelected}} <strong> {{itemCount}} {{itemCount > 1 ? bidListActionBarTranslations.textVehicles : bidListActionBarTranslations.textVehicle}}</strong>
          {{bidListActionBarTranslations.bidListSelect}} <strong>{{bidListActionBarTranslations.bidListRemove}}</strong> {{bidListActionBarTranslations.bidListText}}
        </p>
        <div class="action-list-buttons">
          <button
            data-test-id="app-bidlist-action-bar-e-remove-button" data-testid="bidlist-action-bar-remove-button"
            class="btn btn-outline-primary"
            type="button"
            id="remove_all_selected"
            [attr.allytmln]="'Remove Selected'"
            [attr.aria-label]="bidListActionBarTranslations.ariaLabelBtnRemove"
            (click)="removeAllSelected()"
            >
            {{bidListActionBarTranslations.remove}} ({{itemCount}})
          </button>
          <button
            data-test-id="app-bidlist-action-bar-e-cancel-button" data-testid="bidlist-action-bar-cancel-button"
            class="btn btn-link"
            type="button"
            id="cancel_generation"
            [attr.allytmln]="'Cancel Remove Selected'"
            [attr.aria-label]="bidListActionBarTranslations.ariaLabelBtnCancel"
            (click)="cancel()"
            >
            {{bidListActionBarTranslations.cancel}}
          </button>
        </div>
      </ng-container>
    </div>
  }
</ng-container>
